import {FC} from 'react';
import {
	getPostInnFlowConfig,
	RegistrationFlowConfig,
	RegistrationWorkStatus,
	WORK_STATUS_ICONS_FULL_SCREEN,
} from '../../model';
import {StepLayout} from '../components/StepLayout/StepLayout';

type Props = {
	workStatus: RegistrationWorkStatus | null;
	registrationFlow: RegistrationFlowConfig;
	selfEmploymentProvider?: string | null;
};

export const MyTaxIntroStep: FC<Props> = ({workStatus, registrationFlow, selfEmploymentProvider}) => {
	const config = getPostInnFlowConfig(workStatus, {registrationFlow, selfEmploymentProvider});
	const Illustration = WORK_STATUS_ICONS_FULL_SCREEN[workStatus ?? 'self_employment'];

	return (
		<StepLayout variant="fill">
			<StepLayout.Intro title={config.intro.title} subtitle={config.intro.description} />

			<StepLayout.Illustration size="big">
				<Illustration />
			</StepLayout.Illustration>
		</StepLayout>
	);
};
